import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { useAccount } from './account';
import { Shell } from './Shell';

function Application(): React.JSX.Element {
  const { account, actions } = useAccount();
  return (
    <BrowserRouter>
      <Shell account={account} actions={actions} />
    </BrowserRouter>
  );
}

const rootElement = document.getElementById('root');
if (rootElement === null) throw new Error('Application root element is missing.');
createRoot(rootElement).render(
  <StrictMode>
    <Application />
  </StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'));
}
